import React from "react";
import i18n from "../../../../constants/i18n";
import { ADMIN_POOLS_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import getPoolStore from "../../../../stores/auditor-store/pool-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const PoolData = withLiteObserverAndTheme(() => {
  const {
    adminApprovalPoolData,
    adminReportPoolData,
    adminInvestigationCasesPoolData,
    adminAuditEventsPool
  } = getPoolStore().getPoolData();

  return (
    <React.Fragment>
      <Et3Table
        columns={ADMIN_POOLS_HEADERS}
        rows={adminApprovalPoolData}
        title={i18n.get("APPROVAL_POOL_TABLE")}
        shouldBeFlagged={false}
        titleKey={"APPROVAL_POOL_TABLE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={ADMIN_POOLS_HEADERS}
        rows={adminReportPoolData}
        title={i18n.get("REPORT_POOL_TABLE")}
        shouldBeFlagged={false}
        titleKey={"REPORT_POOL_TABLE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={ADMIN_POOLS_HEADERS}
        rows={adminInvestigationCasesPoolData}
        title={i18n.get("INVESTIGATION_CASES_POOL_TABLE")}
        shouldBeFlagged={false}
        titleKey={"INVESTIGATION_CASES_POOL_TABLE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={ADMIN_POOLS_HEADERS}
        rows={adminAuditEventsPool}
        title={i18n.get("AUDIT_EVENTS_POOL_TABLE")}
        shouldBeFlagged={false}
        titleKey={"AUDIT_EVENTS_POOL_TABLE"}
      />
    </React.Fragment>
  );
});
export default PoolData;
